import Sidebar from "./pages/Sidebar";

function App() {
  return (
    <div>
      <Sidebar />
    </div>
  );
}

export default App;
